import { BLOCK_SIZE, GOAL_COLOR } from './utils'
import Ground from './Ground'
class Goal extends Ground {
  constructor(gridSpot) {
    super(gridSpot)
    this.type = 'GOAL'
  }

  draw(c) {
    c.beginPath()
    c.strokeStyle = '#cdcdcd'
    c.rect(this.x, this.y, BLOCK_SIZE, BLOCK_SIZE)
    c.fillStyle = GOAL_COLOR
    c.fill()
    c.stroke()
    c.closePath()
  }

  update(c) {
    this.draw(c)
  }
}

export default Goal
